(ns teamoesterreich.admin-mode.event-alarm.detail.alarm-overview
  (:require [clojure.string]
            [goog.string.format]
            [reagent-material-ui.components :as mui]
            [reagent.core :as r]
            [goog.json :as json]
            [clojure.string :as str]
            [teamoesterreich.util.log :as log]

            [teamoesterreich.view-state :as store]
            [teamoesterreich.admin-mode.actions :as a]
            [teamoesterreich.admin-mode.data.eventAlarm :as d-eventAlarm]

            [teamoesterreich.admin-mode.event-alarm.detail.alarm-stepper :as alarm-stepper]
            [teamoesterreich.admin-mode.event-alarm.detail.alarm-form :as alarm-detail-form]
            [teamoesterreich.admin-mode.event-alarm.detail.alarm-user-table :as alarm-user-table]

            ))



(defn get-tab-content []
  (let [!alarm (r/cursor store/app-state [:selected-alarm])
        !actual-user (r/cursor store/app-state [:actual-user])
        !tab (r/cursor store/app-state [:alarm-tab])
        !event-detail-loaded? (r/cursor store/app-state [:alarm-detail-loaded])
        alarm-status (or (:eventAlarm-status @!alarm) "prepare")
        ]
    [mui/card {}
     [mui/card-content {}
      (log/debug "Open Tab " @!tab)
      [mui/tabs {:value          @!tab
                 :onChange       (fn [x i y] (log/debug "set tab " x i y) (reset! !tab i))
                 :indicatorColor "primary"
                 :textColor      "primary"
                 :variant        "scrollable"
                 }
       [mui/tab {:value 0 :label "Details"}]

       [mui/tab {:value 2 :label (str "zu alarmieren (" (count (:_eventAlarm-alarmable @!alarm)) ")")}]
       [mui/tab {:value 3 :label (str "alarmiert (" (count (:_eventAlarm-alarmed @!alarm)) ")")}]

       (when (or (= (:tom-id @!actual-user) 1) (= (:tom-id @!actual-user) 53177)) [mui/tab {:value 99 :label (str "RAW für " (:tom-id @!actual-user))}])

       ;(when true [mui/tab {:value 9 :label (str "Verlauf")}])
       ]

      (case (or @!tab 0)
        0 [alarm-detail-form/get-it !alarm !event-detail-loaded? (not= alarm-status "prepare")]
        2 [alarm-user-table/get-it !alarm !event-detail-loaded? :alarmable (not= alarm-status "prepare")]
        3 [alarm-user-table/get-it !alarm !event-detail-loaded? :alarmed (not= alarm-status "prepare")]

        99 [:p "Übersicht über Alarm....." [:pre {:style {:textAlign "left"}} (str/replace (json/serialize (clj->js @!alarm)) "," ",\n")]]

        [:p "or else " @!tab]
        )

      ]]))



(defn get-it []
  (let [!eventAlarm (r/cursor store/app-state [:selected-alarm])
        !alarmUuid (r/cursor store/app-state [:path :entityId])
        !alarm-detail-loaded? (r/cursor store/app-state [:alarm-detail-loaded])
        ]

    (println "Actual alarm " @!alarm-detail-loaded? "\n" @!alarmUuid)
    (when (nil? @!alarmUuid)
      (a/set-page :event-alarm))

    [mui/grid
     {:container  true
      :direction  "row"
      :justify    "flex-start"
      :alignItems "flex-start"
      :spacing    1
      }
     (when (or (not @!alarm-detail-loaded?) (not= @!alarmUuid (:eventAlarm-uuid @!eventAlarm)))
       (d-eventAlarm/<alarm-load @!alarmUuid
                                 (fn [response]
                                   (reset! !eventAlarm response)
                                   (reset! !alarm-detail-loaded? true)
                                   ))
       [mui/grid
        {:container false :item true
         :md        12                                      ;medium: 960px
         :xs        12                                      ;extra-small: 0px
         :style     {:marginTop "5px"}
         }
        [mui/circular-progress {:variant_ "determinate" :color_ "secondary" :size 40 :style {:marginTop "40px"}}]
        [mui/typography {} "Lade Daten ... "]
        ])
     (when @!alarm-detail-loaded?
       [mui/grid
        {:container false :item true
         :md        12                                      ;medium: 960px
         :xs        12                                      ;extra-small: 0px
         :style     {:marginTop "5px"}
         }
        [alarm-stepper/get-it]
        ])
     (when @!alarm-detail-loaded?
       [mui/grid
        {:container false :item true
         :md        12                                      ;medium: 960px
         :xs        12                                      ;extra-small: 0px
         :style     {:marginTop "5px"}
         }
        [get-tab-content]
        ])

     ]

    ))
















